const getSessionStorage = (): boolean => {
    try {
        return !!window.sessionStorage
    } catch (error) {
        return true
    }
}

export default getSessionStorage;